import IntentionPrayersRouterPage from '@/src/app/intention/[id]/prayers'

export default IntentionPrayersRouterPage
